import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";

const BuyerCompanyInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
}) => {
  return (
    <div className="Buyer-company-info">
      <div className="Buyer-company-info_column">
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="COMPANY_NAME"
          label="Company Name"
          value={data.COMPANY_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="COMPANY_ADDRESS"
          label="Company Address"
          value={data.COMPANY_ADDRESS}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="COMPANY_CITY"
          label="City"
          value={data.COMPANY_CITY}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-company-info_column_item"
          data={data}
          optionsType="states"
          optionKey="abbr"
          optionLabelKey="name"
          value={data.COMPANY_STATE}
          valueKey="COMPANY_STATE"
          label="State"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="COMPANY_ZIP"
          label="Zip"
          value={data.COMPANY_ZIP}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
    </div>
  );
};

export default BuyerCompanyInfo;
